export default "__VITE_ASSET__Cr_K4gja__"